import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import MenuItem from '@material-ui/core/MenuItem';
import { TextField } from 'formik-material-ui';
import InputErrorMessage from '../../../InputErrorMessage';
import { formatCurrency } from '../../../../helpers';
import {
  RETAINER_ARCH_OPTIONS,
  RETAINER_ATTRIBUTES,
  RETAINER_CUT_TYPE_OPTIONS,
  RETAINER_QUESTIONS
} from '../constants';

const OPTION_PRICE_KEYS = {
  1: 'straight_cut',
  2: 'scalloped_cut'
};

const BOTH_ARCH_VALUE = RETAINER_ARCH_OPTIONS.find(option => option.label === 'Both').value;

const RetainerCutTypeField = ({ label, fees, ...props }) => {
  const { values } = useFormikContext();
  const archValue = values[RETAINER_ATTRIBUTES.ARCH_TYPE];
  const hasArch = archValue !== '' && archValue != null;
  const isBoth = Number(archValue) === BOTH_ARCH_VALUE;

  return (
    <>
      <Field
        component={TextField}
        select
        variant="outlined"
        fullWidth
        label={label || RETAINER_QUESTIONS[RETAINER_ATTRIBUTES.RETAINER_CUT_TYPE]}
        {...props}
        required
      >
        {RETAINER_CUT_TYPE_OPTIONS.map(option => {
          const priceKey = `${OPTION_PRICE_KEYS[option.id]}_${
            isBoth ? 'both_arches' : 'single_arch'
          }`;
          const price = hasArch && fees ? fees[priceKey] : 0;
          const optionLabel = price > 0 ? `${option.name} | ${formatCurrency(price)}` : option.name;

          return (
            <MenuItem key={option.id} value={String(option.id)}>
              {optionLabel}
            </MenuItem>
          );
        })}
      </Field>
      <ErrorMessage
        name={props.name}
        render={message => <InputErrorMessage>{message}</InputErrorMessage>}
      />
    </>
  );
};

RetainerCutTypeField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  fees: PropTypes.object
};

RetainerCutTypeField.defaultProps = {
  label: null,
  fees: null
};

export default RetainerCutTypeField;
